module.exports = __webpack_public_path__ + "img/camry.c65efd41.png";